import type { AnnouncementLocale } from "../../types";

type AnnouncementLocaleTabsProps = {
  activeLocale: AnnouncementLocale;
  englishComplete: boolean;
  japaneseComplete: boolean;
  onChange: (locale: AnnouncementLocale) => void;
};

/**
 * お知らせ本文の表示言語を切り替えるタブ
 *
 * @param props.activeLocale - 現在表示している言語
 * @param props.englishComplete - 英語のタイトルと本文が入力済みか
 * @param props.japaneseComplete - 日本語のタイトルと本文が入力済みか
 * @param props.onChange - 表示言語を変更する処理
 * @returns 言語切り替えタブ
 */
export const AnnouncementLocaleTabs = ({
  activeLocale,
  englishComplete,
  japaneseComplete,
  onChange,
}: AnnouncementLocaleTabsProps) => {
  return (
    <div className="announcement-locale-tabs" role="tablist" aria-label="表示言語">
      <button
        className={`announcement-locale-tab ${activeLocale === "en" ? "announcement-locale-tab--active" : ""}`}
        type="button"
        role="tab"
        aria-selected={activeLocale === "en"}
        onClick={() => onChange("en")}
      >
        English
        <span
          className={`announcement-locale-tab__indicator ${englishComplete ? "announcement-locale-tab__indicator--complete" : ""}`}
          aria-hidden="true"
        />
      </button>
      <button
        className={`announcement-locale-tab ${activeLocale === "ja" ? "announcement-locale-tab--active" : ""}`}
        type="button"
        role="tab"
        aria-selected={activeLocale === "ja"}
        onClick={() => onChange("ja")}
      >
        日本語
        <span
          className={`announcement-locale-tab__indicator ${japaneseComplete ? "announcement-locale-tab__indicator--complete" : ""}`}
          aria-hidden="true"
        />
      </button>
    </div>
  );
};
